import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import OutlinedText from "components/Input/OutlinedText/OutlinedText";
import Selection from "components/Input/Selection/Selection";
import paymentGatewayOptions from "utils/paymentGatewayOptions/PaymentGatewayOptions.jsx";
import transactionCurrencyOptions from "utils/transactionCurrencyOptions/TransactionCurrencyOptions.jsx";
import s from "./CreateFormContent.module.scss";

const CreateFormContent = ({ handleInput, data }) => {
  const { t } = useTranslation();
  const [inputData, setInputData] = useState({
    paymentGateway: "",
    currencyCode: "",
  });
  const [focus, setFocus] = useState({});

  const textInputOnchange = (e, field, callback) => {
    let { value } = e.target;
    if (callback) {
      value = callback(value);
    }
    handleInput(value, field);
  };
  const textInputOnFocus = (field) => {
    setFocus({ [field]: true });
  };
  const textInputOnBlur = (field) => {
    setFocus({ [field]: false });
  };

  const paymentGatewayOnChange = (value) => {
    setInputData({ ...inputData, paymentGateway: value });
    return value;
  };

  const currencyCodeOnChange = (value) => {
    setInputData({ ...inputData, currencyCode: value });
    return value;
  };

  return (
    <div className={s.contentContainer}>
      <div>
        <OutlinedText
          label={t("page.finance.debit.pending.list.create.function.dialog.content.1")}
          mandatory
          defaultValue={data && data.merchantId ? data.merchantId : ""}
          noErrorMessage
          onchangeFn={(e) => textInputOnchange(e, "merchantId")}
          onfocusFn={() => textInputOnFocus("merchantId")}
          onblurFn={() => textInputOnBlur("merchantId")}
          sxParams={{ textFocus: focus.merchantId }}
        />
      </div>

      <div>
        <Selection
          label={t("page.finance.debit.pending.list.create.function.dialog.content.2")}
          selectionValue={inputData.paymentGateway}
          noErrorMessage
          onchangeFn={(e) =>
            textInputOnchange(e, "paymentGateway", paymentGatewayOnChange)
          }
          onfocusFn={() => textInputOnFocus("paymentGateway")}
          onblurFn={() => textInputOnBlur("paymentGateway")}
          options={paymentGatewayOptions("all")}
          sxParams={{ selectionFocus: focus.paymentGateway }}
        />
      </div>

      <div>
        <Selection
          label={t("page.finance.debit.pending.list.create.function.dialog.content.3")}
          mandatory
          selectionValue={inputData.currencyCode}
          noErrorMessage
          onchangeFn={(e) =>
            textInputOnchange(e, "currencyCode", currencyCodeOnChange)
          }
          onfocusFn={() => textInputOnFocus("currencyCode")}
          onblurFn={() => textInputOnBlur("currencyCode")}
          options={transactionCurrencyOptions("all")}
          sxParams={{ selectionFocus: focus.currencyCode }}
        />
      </div>

      <div>
        <OutlinedText
          label={t("page.finance.debit.pending.list.create.function.dialog.content.4")}
          noErrorMessage
          onchangeFn={(e) => textInputOnchange(e, "debitAmount")}
          onfocusFn={() => textInputOnFocus("debitAmount")}
          onblurFn={() => textInputOnBlur("debitAmount")}
          sxParams={{ textFocus: focus.debitAmount }}
        />
      </div>

      <div>
        <OutlinedText
          label={t("page.finance.debit.pending.list.create.function.dialog.content.5")}
          noErrorMessage
          onchangeFn={(e) => textInputOnchange(e, "reason")}
          onfocusFn={() => textInputOnFocus("reason")}
          onblurFn={() => textInputOnBlur("reason")}
          sxParams={{ textFocus: focus.reason }}
        />
      </div>
    </div>
  );
};

export default React.memo(CreateFormContent);
